import React from "react";
import { useTranslation } from "react-i18next";
import Profileportfolio from "../assets/images/profileportfolio.jpeg";

const Eyebrow = ({ children }) => {
  const commentText = "//";
  return (
    <div className="eyebrow" aria-hidden>
      <span>{commentText}</span> {children}
    </div>
  );
};

const Pill = ({ children }) => <span className="pill">{children}</span>;

const Kpi = ({ value, label }) => (
  <div className="kpi">
    <div className="kpi__value">
      {value}
      <span className="kpi__plus">+</span>
    </div>
    <div className="kpi__label">{label}</div>
  </div>
);

function AboutCard() {
  const { t } = useTranslation();
  
  return (
    <section id="about" className="card about">
      <div className="about__left">
        <div className="avatar">
          <div className="avatar__ring" />
          <div className="avatar__img" role="img" aria-label="Profile">
            <img src={Profileportfolio} alt="Mouad Kasmi" className="avatar__photo" />
          </div>
        </div>
        <div className="hello">
          <span className="hello__dot" />
          <span>{t('about.hello')}</span>
        </div>
      </div>

      <div className="about__right">
        <Eyebrow>{t('about.eyebrow')}</Eyebrow>
        <h2 className="about__title">{t('about.title')}</h2>
        <p className="about__lead">
          {t('about.lead')}
        </p>

        <div className="about__tags">
          <Pill>{t('about.tags.frontend')}</Pill>
          <Pill>{t('about.tags.backend')}</Pill>
          <Pill>{t('about.tags.ai')}</Pill>
        </div>

        <div className="about__kpis">
          <Kpi value="2" label={t('about.kpis.experience')} />
          <Kpi value="40" label={t('about.kpis.hours')} />
          <Kpi value="10" label={t('about.kpis.projects')} />
        </div>
      </div>
    </section>
  );
}

export default AboutCard;
